import { render, staticRenderFns } from "./userDetailsPieChart.vue?vue&type=template&id=d1a71ade&scoped=true"
import script from "./userDetailsPieChart.vue?vue&type=script&lang=js"
export * from "./userDetailsPieChart.vue?vue&type=script&lang=js"
import style0 from "./userDetailsPieChart.vue?vue&type=style&index=0&id=d1a71ade&lang=scss&scoped=true"
import style1 from "./userDetailsPieChart.vue?vue&type=style&index=1&id=d1a71ade&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a71ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1a71ade')) {
      api.createRecord('d1a71ade', component.options)
    } else {
      api.reload('d1a71ade', component.options)
    }
    module.hot.accept("./userDetailsPieChart.vue?vue&type=template&id=d1a71ade&scoped=true", function () {
      api.rerender('d1a71ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/historical/user-details-view/charts/userDetailsPieChart.vue"
export default component.exports